<template>
  <h2 class="pb-2 border-bottom">Serviços de Otomodelagem (Redefinição Não Cirúrgica de Orelhas)</h2>
  <div class="otomodeling-flex">
    <div class="otomodeling-content">
      <p>A otomodelagem, também conhecida como redefinição não cirúrgica de orelhas, é um procedimento minimamente invasivo projetado para corrigir orelhas proeminentes, assimetria ou contornos irregulares das orelhas sem a necessidade de otoplastia tradicional.</p>

      <h5>Quem Pode se Beneficiar da Otomodelagem?</h5>
      <ul>
        <li>Pacientes com Orelhas Proeminentes – Aqueles que desejam uma posição mais equilibrada das orelhas</li>
        <li>Orelhas Assimétricas – Pessoas com formas ou tamanhos de orelhas desiguais</li>
        <li>Deformidades Leves nas Orelhas – Pequenas irregularidades que não requerem cirurgia</li>
        <li>Clientes em Busca de Alternativas Não Cirúrgicas – Pacientes que desejam uma correção sutil, sem cicatrizes</li>
      </ul>

      <h5>Técnicas de Otomodelagem que Você Pode Oferecer</h5>
      <ul>
        <li>Preenchimentos com Ácido Hialurônico para Redefinição de Orelhas
          <ul>
            <li>Adiciona volume a áreas ocas ou desiguais</li>
            <li>Melhora a simetria e suaviza irregularidades na cartilagem</li>
            <li>Procedimento rápido com tempo de inatividade mínimo</li>
          </ul>
        </li>
        <li>Fios para Contorno de Orelhas (Fios PDO ou PLLA)
          <ul>
            <li>Usados para remodelar o ângulo e a posição da orelha</li>
            <li>Proporciona um efeito lifting para um visual mais equilibrado</li>
            <li>Resultados não permanentes, mas duradouros (12-18 meses)</li>
          </ul>
        </li>
        <li>Rejuvenescimento do Lóbulo da Orelha (Preenchimento ou Terapia PRP)
          <ul>
            <li>Restaura o volume de lóbulos finos ou flácidos</li>
            <li>Ajuda com rugas no lóbulo ou danos pós-brinco</li>
            <li>Previne que brincos rasguem ou estiquem o lóbulo</li>
          </ul>
        </li>
      </ul>

      <h5>Visão Geral do Procedimento de Otomodelagem</h5>
      <ul>
        <li>Consulta & Avaliação – Avaliar forma das orelhas, simetria e objetivos do paciente</li>
        <li>Anestesia Local ou Creme Anestésico – Garante um procedimento confortável</li>
        <li>Injeção de Preenchimentos ou Colocação de Fios – Técnica personalizada com base nas necessidades do paciente</li>
        <li>Resultados Imediatos – Sem tempo de inatividade, leve inchaço por 24-48 horas</li>
        <li>Visita de Acompanhamento</li>
      </ul>
    </div>
    <div class="otomodeling-video">
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08);" src="https://www.youtube.com/embed/9rbA47bOvms" title="YouTube Shorts: Ear Lobe Repair" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EarLobeRepairContentPtBR'
};
</script>

<style scoped>
.otomodeling-flex {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 1.5rem;
}
.otomodeling-content {
  flex: 1 1 340px;
  min-width: 0;
}
.otomodeling-video {
  flex: 0 0 340px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
@media (max-width: 900px) {
  .otomodeling-flex {
    flex-direction: column;
    gap: 1.5rem;
  }
  .otomodeling-video {
    justify-content: flex-start;
    margin: 0 auto;
  }
}
</style>
